var _path;

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import React from "react";

var SvgPlane = function SvgPlane(_ref) {
  var svgRef = _ref.svgRef,
      title = _ref.title,
      props = _objectWithoutProperties(_ref, ["svgRef", "title"]);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 24,
    height: 24,
    viewBox: "0 0 24 24",
    fill: "none",
    ref: svgRef
  }, props), title ? /*#__PURE__*/React.createElement("title", null, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M18.6667 9.77778H14.6982L11.0489 3.39095C11.0002 3.30591 10.93 3.23525 10.8452 3.1861C10.7605 3.13696 10.6642 3.11108 10.5663 3.11108H8.29195C7.92285 3.11108 7.65653 3.46421 7.75792 3.81907L9.46036 9.77778H5.88881L4.38881 7.77777C4.28395 7.63784 4.11901 7.55555 3.94436 7.55555H2.55581C2.19435 7.55555 1.92907 7.89513 2.01692 8.24583L3.11102 12L2.01692 15.7542C1.92907 16.1049 2.19435 16.4445 2.55581 16.4445H3.94436C4.11936 16.4445 4.28395 16.3622 4.38881 16.2223L5.88881 14.2222H9.46036L7.75792 20.1806C7.65653 20.5355 7.92285 20.8889 8.29195 20.8889H10.5663C10.7656 20.8889 10.9496 20.782 11.0486 20.6091L14.6982 14.2222H18.6667C19.8941 14.2222 22 13.2274 22 12C22 10.7726 19.8941 9.77778 18.6667 9.77778Z",
    fill: "black"
  })));
};

var ForwardRef = /*#__PURE__*/React.forwardRef(function (props, ref) {
  return /*#__PURE__*/React.createElement(SvgPlane, _extends({
    svgRef: ref
  }, props));
});
export default __webpack_public_path__ + "static/media/plane.1855ab29.svg";
export { ForwardRef as ReactComponent };